import ProductSettingsActions from './duck'
import ProductSettingsSelectors from './selectors'
import { createItemListOnceHook } from 'modules/utils/helpers/createItemListOnceHook'

export const useProductSettingsList = createItemListOnceHook(
  ProductSettingsSelectors,
  ProductSettingsActions.listRequested,
)
